import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-school-or-district",
	templateUrl: "./school-or-district.component.html",
	styleUrls: ["./school-or-district.component.css"],
})
export class SchoolOrDistrictComponent implements OnInit {
	constructor(public ref: DynamicDialogRef, private dialogConfig: DynamicDialogConfig) {}

	ngOnInit(): void {
		this.SchoolName = this.dialogConfig.data.SchoolName;
	}

	SchoolName: any = "";

	onDistrictAdd() {
		this.onClose(0);
	}

	onSchoolAdd() {
		this.onClose(1);
	}

	//-1 cancel, 0 district, 1 school
	onClose(val) {
		this.ref.close(val);
	}
}
